<app-split-login *ngIf="loadedView && !defaultLogin"
  [splitLoginDefinitionDto]="loadViewResponse.viewRootElementDto.splitLoginDefinitionDto" [username]="username"
  [password]="password" [contextIdDto]="contextIdDto" [logoUrl]="logoUrl">
</app-split-login>

<app-login-default *ngIf="loadedView && defaultLogin" [contextIdDto]="contextIdDto" [username]="username"
  [password]="password" [loginImageUrl]="loginImageUrl" [hostname]="hostname" [logoUrl]="logoUrl">
</app-login-default>
